import { createContext } from "react";
interface AuthContextType {
  user: any;
  login: (username: string) => void;
  logout: () => void;
}
let AuthContext = createContext<AuthContextType>(null!);
export default AuthContext;
